module.exports = __webpack_public_path__ + "img/DW365-134.3c1f65ac.jpg";